export const constants = {
  timeoutURI: '/pages/sms/ess/v3/ws/public/timeout',
  checkSessionEndPoint: '/pages/sms/ess/v3/ws/rest/pub/ssr/check',
  sessionTimeoutEndPoint: '/pages/sms/ess/v3/ws/rest/pub/ssr/sessionTimeOut',
  warningTime: 1050000,
  signoutTime: 1170000,
  userActivityCutoff: 600000,
};
